module.exports = __webpack_public_path__ + "img/resources-article-mens-exercises@2x.76b06c7a.jpg";